module.exports = __webpack_public_path__ + "img/icons_2.ffc9a9f0.svg";